
// @ts-nocheck
import { YandexPayController } from '~/lib/yandexPay';
import { YaPaySdk } from '~/types/yaPay';

declare var YaPay: YaPaySdk.YaPay | undefined;

export default {
    props: {
        price: {
            type: Number,
            required: true
        },
        big: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        session: null
    }),
    async mounted() {
        const instance = await YandexPayController.getInstance();
        this.session = await instance.createSession(this.price);

        if (this.session) {
            this.session.mountWidget(this.$el as HTMLElement, {
                widgetType: this.big ? YaPay!.WidgetType.Ultimate : YaPay!.WidgetType.Info
            })
        }
    },
    beforeDestroy() {
        if (this.session) {
            this.session.unmountWidget(this.$el as HTMLElement);
        }
    },
    watch: {
        price() {
            if (this.session) {
                this.session.update(() => ({totalAmount: this.price.toFixed(2)}))
            }
        }
    }
};

